import { useContext, useEffect, useState } from 'react';
import { request } from '../api/client';
import { PgMonitorContext, PgMonitorPanel } from './PgSettlementMonitor';

export default function PgPayoutMonitor({ rows }) {
  const monitor = useContext(PgMonitorContext);
  const [providers, setProviders] = useState([]);
  const [pending, setPending] = useState(true);
  const [attempt, setAttempt] = useState(0);
  const key = JSON.stringify(rows.map((r) => [r.settlement_id ?? r.settlementId ?? null, r.pg_provider ?? r.pgProvider ?? '']));
  useEffect(() => {
    if (!monitor?.active) return;
    const abort = new AbortController(); setPending(true);
    (async () => {
      const found = [];
      for (const [id, provider] of JSON.parse(key)) {
        if (provider) { found.push(String(provider).toUpperCase()); continue; }
        if (id == null) { found.push(''); continue; }
        try {
          const data = await request({ url: '/api/admin/cp-settlement/detail', params: { id }, signal: abort.signal, timeout: 10000 });
          found.push(String(data?.settlement?.pg_provider || '').toUpperCase());
        } catch (_) { found.push(''); }
        if (abort.signal.aborted) return;
      }
      if (!abort.signal.aborted) { setProviders(found); setPending(false); }
    })();
    return () => abort.abort();
  }, [key, attempt, monitor?.active]);
  if (!monitor?.active || monitor.config?.enabled === false) return null;
  return <div className="px-4 pt-3">{pending ? <p>지급 대상 PG 확인 중…</p> : <>
    {providers.includes('') && <p className="mb-2 text-sm text-amber-900">일부 지급 대상의 PG를 확인할 수 없습니다. 갤럭시아로 추정하지 않습니다. <button type="button" onClick={() => setAttempt((n) => n + 1)} className="underline">PG 다시 확인</button></p>}
    {providers.includes('BILLGATE') && <>{providers.some((p) => p !== 'BILLGATE') && <p className="mb-2 text-sm font-bold">아래 검사는 선택된 갤럭시아 지급 부분에 대한 계정 전체 안내입니다. 다른 PG의 지급 검증이 아닙니다.</p>}<PgMonitorPanel compact onOpen /></>}
  </>}</div>;
}
